export enum ListBuilderTableColumns {
    LIST_BUILDER_NAME = "name",
    STATUS = "status",
    LAST_BUILD = "lastBuild",
    BUILD_LIST_BUTTON = "buildListButton",
    DOWNLOAD_BUTTON = "downloadButton",
    EDIT_BUTTON = "editButton",
    DUPLICATE_BUTTON = "duplicateButton",
    DELETE_BUTTON = "deleteButton",
}

export enum SortableListBuilderColumns {
    LIST_BUILDER_NAME = "name",
    STATUS = "status",
    LAST_BUILD = "lastBuild",
}
